import(/* webpackMode: "eager" */ "/app/components/layout/Footer/FooterContact/FooterContact.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/terminos-y-condiciones/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FooterContactDetails"] */ "/app/components/layout/Footer/FooterContact/FooterContactDetails/FooterContactDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCopyrightLinks"] */ "/app/components/layout/Footer/FooterContact/FooterCopyrightLinks/FooterCopyrightLinks.tsx");
